import React, { memo, useMemo } from 'react';
import createHeartComponent, { SaveAdProps as HeartProps } from '@finn-no/favorite-heart-component';

import { forwardRef } from 'react';
import { useUserId } from './useUserId.js';
import { useDeviceType } from './useDeviceType.js';
import { useActiveAds } from '../ActiveAdsContext.js';

const SaveAdContext = React.createContext<
    ReturnType<typeof createHeartComponent>
>(() => <React.Fragment />);

type SaveAdProviderProps = {
    children: React.ReactNode;
};

export const SaveAdProvider = ({ children }: SaveAdProviderProps) => {
    const userId = useUserId();
    const { apis } = useActiveAds();

    const Heart = useMemo(
        () =>
            memo(
                createHeartComponent({
                    baseUri: apis.favorites,
                    userId: userId,
                }),
            ),
        [userId],
    );

    // const Heart = createHeartComponent({
    //     baseUri: apis.favorites,
    //     userId: userId,
    // })

    return <SaveAdContext.Provider value={Heart}>{children}</SaveAdContext.Provider>;
};

type SaveAdProps = Omit<HeartProps, 'isMobile' | 'itemType'>;

export const SaveAd = forwardRef((props: SaveAdProps, forwardRef) => {
    const Heart = React.useContext(SaveAdContext);
    const deviceType = useDeviceType();

    return <Heart ref={forwardRef} itemType="Ad" isMobile={deviceType !== 'desktop'} {...props} />;
});
